import React from 'react';

import DashboardWidgetWrapper from '../DashboardWidgetWrapper';

const MediaAnalysisWidget = () => {
	return (
		<DashboardWidgetWrapper label={'Media Analysis'}>
			<p>Hello</p>
		</DashboardWidgetWrapper>
	);
};

MediaAnalysisWidget.propTypes = {};

export default MediaAnalysisWidget;
